export default {
  title: 'Pääte',
  stats: {
    terminal_battery_level: 'Akun varaustaso',
    terminal_battery_state: 'Latauksen tila',
    auto_accept_orders: 'Hyväksy tilaukset automaattisesti',
  },
  auto_accept_orders_modal: {
    title: 'Haluatko varmasti hyväksyä tilaukset automaattisesti?',
    buttons: {
      activate: 'Aktivoi',
      cancel: 'Peruuta',
    },
  },
  feedback: {
    update_success: 'Päivitetty onnistuneesti',
    update_failed: 'Tietojen päivittäminen epäonnistui. Yritä uudelleen.',
  },
};
